import React, { useState, useRef, useEffect, Link } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { alert_error, alert_success } from "../../AppContext.js";
import { Cookies } from '../../index.js';
import axios from 'axios';
import { Helmet } from "react-helmet";
import { useParams } from 'react-router-dom';
import { ClipLoader, PulseLoader } from 'react-spinners';
import BitmediaAd from '../../kiemtien/mission/bitmedia.jsx';
import GeeTest, { GeeTestRef } from 'react-geetest-v4';
import AdSense from 'react-adsense';
const TaskList = () => {
    const { slug_2 } = useParams();
    const [nutorder, setnutorder] = useState("Xác nhận");
    const [gtoken, setgtoken] = useState('');
    const [taskid, settaskid] = useState('');
    const [category, setcategory] = useState('');
    const [urllink, seturllink] = useState('');
    const [nutxuly, setnutxuly] = useState(0);
    const [showmission, setshowmission] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [tasks, settasks] = useState([
        { id: 1, name: 'Tạo profile shop', description: 'Nhận ngay 20 Coins', url: '/reactapp/baohiem' },
        { id: 2, name: 'Đặt Banner lên App', description: 'Nhận ngay 1500 Coins + 100% hạn mức', url: '/shop/ads/adsprofiles' },
        { id: 3, name: 'Mua 1 đơn tăng tương tác kênh hệ mặt trời', description: 'Nhận ngay 100 Coins' },
        { id: 4, name: 'Mua 1 đơn mem nhóm, kênh telegram việt', description: 'Nhận ngay 100 Coins' },
        // Thêm nhiệm vụ khác tại đây
    ]);

    const resetRecaptcha = () => {
        if (slug_2 == 'rollup') {

        }
        else {
            const oldRecaptchaElement = document.querySelector('.g-recaptcha');

            if (oldRecaptchaElement) {
                // Xóa reCAPTCHA cũ
                oldRecaptchaElement.remove();
            }

            // Tạo một phần tử div mới để chứa reCAPTCHA mới
            const newRecaptchaDiv = document.createElement('div');
            newRecaptchaDiv.className = 'g-recaptcha';
            newRecaptchaDiv.setAttribute('data-sitekey', '6LfIRiYeAAAAAH42UB0tN41k5vDRf2OfChCIKxkn');
            newRecaptchaDiv.setAttribute('data-size', 'invisible');

            // Thêm phần tử mới vào DOM
            document.body.appendChild(newRecaptchaDiv);

            // Tải lại reCAPTCHA mới
            window.grecaptcha.ready(() => {
                window.grecaptcha
                    .execute("6LfIRiYeAAAAAH42UB0tN41k5vDRf2OfChCIKxkn", { action: "homepage" })
                    .then(token => {
                        console.log(token);
                        setgtoken(token);
                    });
            });
        }
    };

    const navigate = useNavigate();
    const ok_api = (value, geetoken) => {
        if (value) {
            setnutxuly(1);
            setIsDisabled(true);
            setnutorder('Đợi xíu nhé');
            const myCookieValue = Cookies.get('apikey');
            let data = JSON.stringify({
                "service": value,
                "apikey": myCookieValue,
                "gtoken": gtoken,
                "geetoken": geetoken,
                "category": category
            });
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://hust.media/jop/mission/1short.php',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            axios.post(config.url, config.data, config.headers)
                .then((response) => {
                    setnutxuly(0);
                    testFunction(response);
                    resetRecaptcha();
                    setIsDisabled(false);
                })
                .catch((error) => {
                    setnutxuly(0);
                    alert_error(error);
                    resetRecaptcha();
                    setIsDisabled(false);
                });
        }
        else {
            alert_error('Không lấy được nhiệm vụ vui lòng thử lại');
        }
    }
    const handleGeetestSuccess = (result) => {
        // Xử lý khi xác thực thành công
        setIsOpen(false);
        console.log(result);
        // setgeetoken(result);
        ok_api(taskid, result);
    };
    const submit = (value) => {
        if (slug_2 == 'rollup') {
            setOpenTaskId(value);
            setIsOpen(true);
            settaskid(value);
        }
        else {
            ok_api(value);
        }
    };
    function clickmission(taskIdToFind) {
        if (!isDisabled) {
            console.log(taskIdToFind);
            const task = tasks.find(task => task.id === taskIdToFind);
            if (task) {
                const link = task.url; // Nếu không có URL, trả về giá trị mặc định
                if (link) {
                    navigate(link);
                }
                else {
                    console.log(category);
                    if (category == 'rollup' || category == 'offerwall') {
                        submit(taskIdToFind);
                    }
                    console.log(`không có url`);
                }
            } else {
                console.log(`Không tìm thấy nhiệm vụ với id ${taskIdToFind}`);
            }
        }
    };
    function switch_router(taskIdToFind) {
        if (!isDisabled) {
            const task = tasks.find(task => task.id === taskIdToFind);
            if (task) {
                const link = task.url; // Nếu không có URL, trả về giá trị mặc định
                if (link) {
                    navigate(link);
                }
                else {
                    console.log(category);
                    if (category == 'rollup' || category == 'offerwall') {
                        submit(taskIdToFind);
                    }
                    console.log(`không có url`);
                }
            } else {
                console.log(`Không tìm thấy nhiệm vụ với id ${taskIdToFind}`);
            }
        }
    };
    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;
        setnutxuly(0);
        if (status == 1) {
            setnutorder('Cảm ơn bạn đã ủng hộ');
            alert_success(message);
        }
        else if (status == 0) {
            alert_error(message);
        }
        else {
            setnutorder('Đã xảy ra lỗi vui lòng nhập lại');
            alert_error('Đã xảy ra lỗi vui lòng nhập lại');
        }
        setnutorder('xác nhận');
        if (info.redirect != null && info.redirect != '') {
            if (category == 'rollup') {
                seturllink(info.redirect);
                setIsOpen(true);
            }
            else {
                setTimeout(function () {
                    // Chuyển hướng sang trang web khác
                    window.location.href = info.redirect;
                }, 1700);
            }
        }
    };
    function laythongtin(category) {
        // setmisson(false);
        const myCookieValue = Cookies.get('apikey');
        axios.get('https://hust.media/api/wallet/e_commerce/partner_transaction.php', {
            params: {
                apikey: myCookieValue,
                category: category
            }
        })
            .then(response => {
                if (response.data.status == 0) {
                    alert_error(response.data.message);
                }
                else {
                    console.log(response.data); // Dữ liệu từ API
                    settasks(response.data);
                    setshowmission(true);
                    // setdata(response.data);
                    // setdalaythongtin(true);
                    // Xử lý dữ liệu ở đây
                }
                if (response.data.redirect != null && response.data.redirect != '') {
                    setTimeout(function () {
                        // Chuyển hướng sang trang web khác
                        window.location.href = response.data.redirect;
                    }, 2000);
                }
            })
            .catch(error => {
                setshowmission(true);
                alert_error(error);
            });
    };
    useEffect(() => {
        laythongtin(slug_2);
    }, []);
    const [openTaskId, setOpenTaskId] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const handleClose = () => {
        setIsOpen(false);
        seturllink('');
    };
    return (
        <>
            <div className="w-full mt-1">
                {category == "offerwall" ? (<>
                </>) : (<>
                    <div id="M882924ScriptRootC1520508"></div>
                    {/* <Helmet>
                        <script src="https://jsc.adskeeper.com/h/u/hust.media.1520508.js" async></script>
                    </Helmet>
                    <BitmediaAd /> */}
                </>)}
                {(showmission == false) ? (<>
                    <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">

                        <ClipLoader color="#fff" size={150} />
                    </div>
                </>) : (

                    <>
                        {(tasks == 'nothing') ? (<>
                            <div style={{ textAlign: "center" }} className="mt-4 text-lg text-pink-400 font-bold mx-2 justify-center items-center">
                            🎉 Coins giá rate vip hết sạch rồi! 😅 Bạn thử cách donate khác nhé, hoặc chờ các bạn nhà cung cấp cày thêm Coins nha! 💰✨
                            </div>
                        </>) : (
                            <>
                                <div className="mx-2 mt-1">
                                    <table className="w-full border shadow-lg rounded-lg">
                                        <thead className="bg-blue-500 text-white">
                                            <tr className="lg:table-row">
                                                <th className="border px-3 py-2 w-2/6">Nhà cung cấp</th>
                                                <th className="border px-3 py-2 w-5/6">Mô tả</th>
                                                <th className="border px-2 py-2 w-2/6">Ngày bán</th>
                                                <th className="border px-3 py-2 w-2/6">Xác nhận</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tasks.map((task) => (
                                                <tr key={task.id} className="hover:bg-gray-100">
                                                    <td className="border px-6 py-3 lg:w-2/5 px-3 py-2 ">
                                                        <div className="flex items-center justify-between flex-1"
                                                            onClick={() => clickmission(task.id)} >
                                                            {task.name}
                                                            <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                                                        </div>
                                                    </td>
                                                    <td className="border px-6 py-3 lg:w-2/5 px-3 py-2">
                                                        <div dangerouslySetInnerHTML={{ __html: task.description }} />
                                                    </td>
                                                    <td className="border px-1 py-2 lg:w-2/5 ">
                                                        <div dangerouslySetInnerHTML={{ __html: task.createdate }} />
                                                    </td>
                                                    <td className="border  text-center">
                                                        <button disabled={isDisabled} onClick={() => clickmission(task.id)} className="group rounded-2xl h-12 w-55 bg-pink-300 font-bold text-base text-white relative overflow-hidden">
                                                            {nutxuly == 1 && (<span className="spinner-border spinner-border-sm"></span>)}
                                                            {nutorder}
                                                            <div className="absolute duration-300 inset-0 w-full h-full transition-all scale-0 group-hover:scale-100 group-hover:bg-white/30 rounded-2xl"></div>
                                                        </button>
                                                        {isOpen && (
                                                            <div>
                                                                {openTaskId === task.id && (
                                                                    <div className="absolute z-10 mt-1
                                                        right-3
                                                        rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">

                                                                        <div
                                                                            className="py-1"
                                                                            role="menu"
                                                                            aria-orientation="vertical"
                                                                            aria-labelledby="options-menu"
                                                                        >
                                                                            <div className="flex">
                                                                                <button
                                                                                    onClick={() => handleClose()}
                                                                                    className='text-xl mr-2'>✖</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>)}
                    </>)}
            </div>
            <br/> <br/>
        </>

    );
};

export default TaskList;
